import Component_Sprite_d95b166152f4d38928d2c30b549e0523 from "../../../../content/examples/sprites/Sprite";
import Devtool_Sprite_d95b166152f4d38928d2c30b549e0523 from "!!@devtool/loader!../../../../content/examples/sprites/Sprite";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_Sprite_d95b166152f4d38928d2c30b549e0523,
  Devtool_Sprite_d95b166152f4d38928d2c30b549e0523,
  DevTool,
  React
};